import React, { useContext, useEffect, useState } from 'react';
import FormTemplate from '../../../components/FormTemplate';
import ModalDIgitalDocuments from '../../../components/ModalDigitalDocuments';
import Alert from '../../../components/Alert';
import Loader from '../../../components/Loader';
import { documentSigningSteps, welcomeDownloadDocuments } from '../../../helpers/enum';
import { DocumentSigningContext } from '../../../store';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { H5 } from '../../../components/Typography/styles';
import colors from '../../../assets/styles/colors';
import { DownloadDocumentsButton } from './styles';
import { BsCloudDownload } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import { downloadDigitalDocuments } from '../../../services/document';
import { default as DocumentSigningTypes } from '../../../store/DocumentSigning/types';
import { BsFolderPlus, BsExclamation } from 'react-icons/bs';

const DownloadDocumentsPage = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const { documentSigning, setDocumentSigning } = useContext(DocumentSigningContext);
  const [showModalDigitalDocuments, setShowModalDigitalDocuments] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsData] = useState(true);

  async function initializedStateComponent() {
    try {
      let response = await downloadDigitalDocuments(location.idCredit);
      setIsData(response.data.length > 0);  

      await setDocumentSigning({
        type:  DocumentSigningTypes.SET_DOWNLOAD_DOCUMENTS,
        downloadDocuments: response.data,
      })
      setNextStep();
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
      setIsLoading(false);
    }
  }
  
  async function downloadDocuments() {
    try {
      await documentSigning.downloadDocuments.map(item => {
        const linkSource = `data:application/pdf;base64,${item.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = item.nombre;
  
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })

      await setDocumentSigning({
        type:  DocumentSigningTypes.SET_DISABLED_BUTTON,
        disabledButton: false
      })
    } catch (error) {
      console.log(error)
      console.log(error.response)
    }
  }

  function setNextStep() {
    setLastStep(documentSigningSteps.DOWNLOAD_DOCUMENTS);
    setActiveStep(documentSigningSteps.UPLOAD_DOCUMENTS);
  }

  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <FormTemplate 
      idForm="download-documents-step-page"
      activeStep="1/1"
      stepLabel="Sube documentos adicionales"
      idCredito={location.idCredit}>
      <Alert
        style={{marginTop: 20}}
        custom
        backgroundAlert={colors.textExGrayLight}
        borderAlert={colors.grayLight}
        backgroundIcon={colors.textHyperlink}
        icon={<BsFolderPlus size={18} color={colors.white} />}
        description={
          <div>
            <div>Estamos en la parte final del proceso, donde solicitaremos que el cliente diligencie algunos documentos físicamente según requerimiento de la pagaduría.</div>
            <div>Además puedes cargar hasta cinco (5) documentos adicionales para complementar la radicación del crédito seleccionando la opción “Documento adicional”.</div>
          </div>
        }
      />
      {/**
      <Alert
        style={{marginTop: 20}} 
        custom
        backgroundAlert={colors.textExGrayLight}
        borderAlert={colors.grayLight}
        backgroundIcon={colors.bgTertiary}
        icon={<BsExclamation size={18} color={colors.textPrimary} />}
        description={
          <div>
            <div>Recuerda, si tienes inconvenientes en la descarga de los documentos en el navegador Chrome, sigue los siguientes pasos:</div>
            <div>1. Da clic tres puntos parte superior derecha navegador.</div>
            <div>2. Selecciona la opción Descargas.</div>
            <div>3. Buscar la descarga correspondiente a DigiCrédito bajo un icono de advertencia.</div>
            <div>4. Clic al botón de Descargar.</div>
            <div>5. Clic en “Mantener de todos modos”.</div>
          </div>
        }
      />*/}

      {isLoading ? <Loader /> : (
        <>
          {/*!isData ? <></> : (
            <Form>
              {documentSigning.downloadDocuments.map((item, key) => (
                <FormRow col="1" key={key}>
                  <H5 color={colors.textPrimary} >{key + 1}. {item.nombre}</H5>
                </FormRow>
              ))}
              <FormRow col="1">
                <DownloadDocumentsButton type="button" onClick={() => downloadDocuments()}>Descargar documentos <BsCloudDownload size={22} /></DownloadDocumentsButton>
              </FormRow>
            </Form>
              )*/}  
          <FormFooter justify="flex-end">
            <SecondaryLargeButton type="button" disabled={documentSigning.disabledButton && isData} onClick={() => setNextStep()}>Siguiente</SecondaryLargeButton>
          </FormFooter>
        </>
      )}
      <ModalDIgitalDocuments 
        open={showModalDigitalDocuments} 
        setShowModal={setShowModalDigitalDocuments}
        body={welcomeDownloadDocuments}
        title={`${documentSigning.solicitation?.cliente.nombres} ${documentSigning.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. ${documentSigning.solicitation?.cliente.identificacion}`}/>
    </FormTemplate>
  )
}

export default DownloadDocumentsPage;
